import styled from 'styled-components';
import { Card, media } from '@minerva-analytics/pantheon';

const PlaythroughCardContainer = styled(Card)`
  border-radius: 30px;
  max-width: calc(800px - 4rem);
  min-height: 510px;
  width: 100%;
  box-shadow: 0 2px 10px 0 rgba(0,0,0,0.10);

  ${media.tablet`
    padding: 0;
  `}
`;

export {
  PlaythroughCardContainer,
};
